import React, {
  useContext,
  useCallback,
  useState,
  useEffect,
  useRef,
} from "react";
import { ContextStore } from "Reducer";
import { useTranslation } from "react-i18next";
import { List } from "immutable";
import useMediaQuery from "useHooks/gameMediaQuery";
import { useHistory } from "react-router-dom";
// components
import Game from "./Main/Game";
import PopModal from "./Main/PopModal";
import Footer from "./Main/Footer";
import GameListEmpty from "./Main/GameListEmpty";
import GoTopDesktop from "Components/GoTopDesktop";

// api
import { putUpdateFavorite, getGameLink } from "api";

// util
import { gameLinkLang } from "Utils/index";
import useScrollTop from "useHooks/useScrollTop";

//style
import {
  Main,
  MainContainer,
  MaxWidthContainer,
} from "Components/common/MainStyled";

const Favorite = () => {
  const {
    state: { stateReducer },
    dispatch,
  } = useContext(ContextStore);
  const [isSticky, setIsSticky] = useState(false);
  const [gamePopup, setGamePopup] = useState(false);
  const stickyHeight = 150;
  const containerRef = useRef();
  const scrollTop = useScrollTop(containerRef);
  const lang = stateReducer.get("lang");
  const searchValue = stateReducer.get("searchValue");
  const gameType = stateReducer.get("gameType");
  const typeList = stateReducer.get("typeList");
  const favorite_game = stateReducer.getIn(
    ["userInfo", "favorite_game"],
    List()
  );
  const mainAreaRoute = stateReducer.get("mainAreaRoute");
  const gameList = stateReducer.get("gameList", List());
  const gameUrl = stateReducer.get("gameUrl");
  const popModalData = stateReducer.get("popModalData");
  const isLoading = stateReducer.get("isLoading");
  const typeValue = gameType.getIn(["value", "type"]);
  const cornerTagList = stateReducer.get("cornerTagList", List());
  const history = useHistory();
  const { t } = useTranslation();
  const mediaType = useMediaQuery();

  const filteredFavoriteGameList = gameList.filter((v) =>
    favorite_game.includes(v.get("game_id"))
  );
  const favorite_gameIdList = filteredFavoriteGameList.map((v) =>
    v.get("game_id")
  );
  const handleHeartClick = (e, game_id, isFavorite) => {
    let favor_game;
    if (isFavorite) {
      favor_game = favorite_gameIdList.filter((v) => v !== game_id);
    } else {
      favor_game = favorite_gameIdList.push(game_id);
    }
    favor_game = favor_game.toJS();
    putUpdateFavorite({ favor_game }, dispatch, history);
    e.stopPropagation();
  };

  const handleOpenPopModal = ({
    game_id,
    icon,
    type,
    isFavorite,
    name,
    source,
  }) => {
    setGamePopup(!gamePopup);
    const params = {
      lang: gameLinkLang(lang),
      game_plat: mediaType,
      game_hall: "cq9",
      gamecode: game_id,
    };

    dispatch({
      type: "CHANGE_DATA",
      path: "popModalData",
      value: {
        game_id,
        icon,
        type,
        isFavorite,
        name,
        source,
      },
    });
    getGameLink({ params, history, dispatch, icon, type, isFavorite, name });
  };
  const handleOpenGame = (e) => {
    // window.open(gameUrl);
    closeGameModal();
    e.stopPropagation();
  };
  const closeGameModal = useCallback(() => {
    setGamePopup(false);
    dispatch({ type: "CHANGE_DATA", path: "gameUrl", value: "" });
  }, [dispatch]);
  useEffect(() => {
    if (mediaType === "web") {
      if (scrollTop > stickyHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }
  }, [mediaType, scrollTop]);
  return (
    <MainContainer ref={containerRef} mainAreaRoute={mainAreaRoute}>
      <MaxWidthContainer>
        <Main>
          <p className="title">{t("myFollowedGames")}</p>
          {!isLoading && (
            <GameListEmpty
              searchValue={searchValue}
              filteredGameList={filteredFavoriteGameList}
              typeValue={typeValue}
            />
          )}
          <Game
            mainAreaRoute={mainAreaRoute}
            gameList={filteredFavoriteGameList}
            gameType={gameType}
            typeList={typeList}
            lang={lang}
            t={t}
            favorite_game={favorite_game}
            handleHeartClick={handleHeartClick}
            handleOpenPopModal={handleOpenPopModal}
            isLoading={isLoading}
            cornerTagList={cornerTagList}
          />
          <PopModal
            gameUrl={gameUrl}
            gamePopup={gamePopup}
            modalData={popModalData}
            closeGameModal={closeGameModal}
            handleHeartClick={handleHeartClick}
            handleOpenGame={handleOpenGame}
            favorite_game={favorite_game}
            t={t}
          />
        </Main>
        <Footer />
        {isSticky && <GoTopDesktop target={containerRef?.current} />}
      </MaxWidthContainer>
    </MainContainer>
  );
};

export default Favorite;
